export default __webpack_public_path__ + "static/media/QRcodeFill.2fa12029.svg";